import GET_SMSREPORT from '@/graphql/SmsReport.gql'
import { ref, reactive, toRefs } from '@vue/composition-api'
import { useQuery, useResult } from '@vue/apollo-composable'

export function useSmsReport(companyId) {
  const date = new Date()
  const state = reactive({
    range: {
      start: new Date(date.getFullYear(), date.getMonth(), 1),
      end: new Date(date.getFullYear(), date.getMonth() + 1, 0),
    },
  })
  const { result, loading, error } = useQuery(
    GET_SMSREPORT,
    () => ({
      where: {
        start: state.range.start.toString(),
        end: state.range.end.toString(),
        companyId: 'test',
      },
    }),
    {
      fetchPolicy: 'cache-and-network',
    },
  )
  const smsReport = useResult(result, [], (data) => data.smsReport)
  return { smsReport, loading, error, ...toRefs(state) }
}
